module.exports = __webpack_public_path__ + "img/ic-pt-mix.8668809c.svg";